import api from '@swipekit/lib/api.js';
import crudStore from '@swipekit/lib/crud-store';

import CrudStore from '@swipekit/lib/crud-store';

let crud = new CrudStore({
	name: 'boards',
	singular: 'board',
});

const state = {
	...crud.state,

	maxRecentBoardIds: 5,

	deleteConfirmationId: null,

	recentBoardIds: [],
};
const getters = {
	...crud.getters,

	deleteConfirmationId: function (state) {
		return state.deleteConfirmationId;
	},

	recentBoardIds: function (state) {
		return state.recentBoardIds;
	},

	boardBySlug: function (state) {
		let resources = state.resources;

		return (slug) => {
			let resource = null;

			//id = parseInt(id);

			// if (isNaN(id)) {
			//   return null;
			// }

			for (let i = 0; i < resources.length; i++) {
				if (resources[i].slug === slug) {
					resource = resources[i];
					break;
				}
			}

			return resource;
		};
	},
	filtered: function (state) {
		let boards = JSON.parse(JSON.stringify(state.resources));

		boards = boards.sort((a, b) => {
			return a.order - b.order;
		});

		return boards;
	},
};
const actions = {
	...crud.actions,

	async init(store) {
		let boardIds = [];
		if (typeof localStorage === 'undefined') {
		} else {
			boardIds = localStorage.getItem('recentBoardIds');
		}
		if (!boardIds) {
			return;
		}

		try {
			boardIds = JSON.parse(boardIds);
			store.state.recentBoardIds = [...boardIds];
		} catch (err) {}
	},

	async afterLogin(store, pie) {
		let mode = store.rootState.config.mode;

		if (store.rootGetters['users/isAuth']) {
			if (mode === 'EXTENSION') {
				await store.dispatch('getLocal');
			} else {
				if (!pie) {
					await store.dispatch('get');
				} else {
					await store.dispatch('consumePie', pie);
				}
			}
		}
	},

	async getLocal(store) {
		let resources = [];
		try {
			resources = await crud.api[crud.resourceName].get('local');
		} catch (err) {
			throw err;
		}

		store.commit('SET', resources);
		return resources;
	},

	async doAction(store, obj) {
		let action = obj.action;
		let id = obj.id;
		let response = await crud.api.api.doAction(id, action);

		return response;
	},

	async getBoardData(store, obj) {
		let action = obj.action;
		let id = obj.id;
		let response = await crud.api.api.doAction(id, action);

		if (response) {
			let user = response.user;
			let blocks = response.blocks;
			let board = JSON.parse(JSON.stringify(response));
			delete board.user;
			delete board.blocks;

			await store.dispatch('ads/get', blocks, { root: true });
			store.commit('UPDATE', board);
		}

		return response;
	},

	async remove(store, id) {
		let condition = false;
		try {
			condition = await crud.api[crud.resourceName].delete(id);
		} catch (err) {
			console.log(err);
			throw err;
		}
		if (condition) {
			store.commit('REMOVE', id);

			await store.dispatch('ads/removeBoard', id, { root: true });
		}

		return condition;
	},

	async fetchAndStore(store) {
		let resources = (await crud.api[crud.resourceName].fetchAndStore()) || [];

		store.commit(resources);
	},

	async setOrder(store, obj) {
		const condition = await api.boards.setOrder(obj);
		if (condition) {
			let currentBoards = JSON.parse(JSON.stringify(store.state.resources));
			currentBoards = currentBoards.map((b) => {
				for (let i = 0; i < obj.boards.length; i++) {
					let newBoard = obj.boards[i];
					if (newBoard.id === b.id) {
						b.order = newBoard.order;
						break;
					}
				}

				return b;
			});

			store.state.resources.splice(
				0,
				store.state.resources.length,
				...currentBoards
			);
		}
	},

	setRecentBoards(store, arr) {
		if (arr.length > store.state.maxRecentBoardIds) {
			arr.splice(store.state.maxRecentBoardIds);
		}

		let boardIds = JSON.parse(JSON.stringify(store.state.recentBoardIds));

		let newBoardIds = boardIds.concat(arr);

		if (newBoardIds.length > store.state.maxRecentBoardIds) {
			newBoardIds.splice(store.state.maxRecentBoardIds);
		}

		store.state.recentBoardIds = [...newBoardIds];

		if (typeof localStorage !== undefined) {
			localStorage.setItem('recentBoardIds', JSON.stringify(newBoardIds));
		}
	},

	consumePie: async (store, pie) => {
		store.commit('SET', pie.workspace.boards || []);
	},

	setClone: async (store, boardId) => {
		const boards = await api.boards.clone(boardId);

		if (boards) {
			store.commit('SET', boards || []);
		}

		return boards || null;
	},

	async setDeleteConfirmationId(store, folder) {
		if (folder) {
			store.state.deleteConfirmationId = folder.id;
		} else {
			store.state.deleteConfirmationId = null;
		}
	},
};
const mutations = {
	...crud.mutations,
};

let store = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};

export default store;
